import { BerthsApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'

class BerthService {
  httpClient = createApiClient(BerthsApi)

  get = async () => {
    const { data } = await this.httpClient.get()
    return data
  }
}

const berthService = new BerthService()

export default berthService
